import React from 'react';
import PropTypes from 'prop-types';
import Form from './../../Form';
import Loading from './../../Loading';
import { flat, expandExtended } from './../../../utils/flat';
import { prepareDecimalFields } from './../../../utils/format';

const FULL_TEXT_FIELDS = [
    'globalMarketSettings.baseCashout',
    'globalMarketSettings.cashoutOverround',
    'globalMarketSettings.offerEasing',
    'algorithmInputSettings.power',
    'algorithmInputSettings.minimum'
];

class CashOutSettingsForm extends Form{
    static propTypes = {
        onCashOutSettingsGetRequest: PropTypes.func
    };

    constructor(props, context) {
        super(props, context);
    }

    static fieldsValidation = {
        'algorithmInputSettings.power': [ 'decimal', [ 'maxPrecision', 2 ], [ 'range', { start: 0, end: 1000 } ] ],
        'algorithmInputSettings.minimum': [ 'decimal', [ 'maxPrecision', 2 ], [ 'range', { start: 0, end: 1000 } ] ],
        'globalMarketSettings.baseCashout': [ 'decimal', [ 'maxPrecision', 2 ], [ 'range', { start: 0, end: 1 } ] ],
        'globalMarketSettings.cashoutOverround': [ 'decimal', [ 'maxPrecision', 2 ], [ 'range', { start: 0, end: 1 } ] ],
        'globalMarketSettings.offerEasing': [ 'decimal', [ 'maxPrecision', 2 ], [ 'range', { start: 0, end: 20 } ] ]
    };

    componentDidMount() {
        this.props.onCashOutSettingsGetRequest();
    }

    UNSAFE_componentWillReceiveProps(props) {
        if (props.data !== this.props.data && status !== 'IN_PROGRESS') {
            this.setState({
                data: props.data
            });
        }
        Form.prototype.UNSAFE_componentWillReceiveProps.apply(this, arguments);
    }

    onSubmit(e) {
        e.preventDefault();
        const { data } = this.state;

        Form.prototype.onSubmit.call(this, e);

        if ( !this.isValid() ) {
            return false;
        }

        this.props.onCashOutSettingsPutRequest( data );
    }

    renderForm() {
        return (
            <div>
                <Loading active={ this.props.status === "IN_PROGRESS" } message="Loading Cash Out settings ..." />
                <div className="row">
                    <div className="col-3">
                        <h4 className="form-field-title">Algorithm Input Settings</h4>
                    </div>
                    <div className="col-4">
                        {
                            this.getField(
                                <input
                                    type="text"
                                    label="Power"
                                    { ...this.getFieldParameters('algorithmInputSettings.power') }
                                />
                            )
                        }
                        {
                            this.getField(
                                <input
                                    type="text"
                                    label="Minimum"
                                    { ...this.getFieldParameters('algorithmInputSettings.minimum') }
                                />
                            )
                        }
                    </div>
                </div>
                <div className="row">
                    <div className="col-3">
                        <h4 className="form-field-title">Global Market Settings</h4>
                    </div>
                    <div className="col-4">
                        {
                            this.getField(
                                <input
                                    type="text"
                                    label="baseCashout"
                                    { ...this.getFieldParameters('globalMarketSettings.baseCashout') }
                                />
                            )
                        }
                        {
                            this.getField(
                                <input
                                    type="text"
                                    label="cashoutOverround"
                                    { ...this.getFieldParameters('globalMarketSettings.cashoutOverround') }
                                />
                            )
                        }
                        {
                            this.getField(
                                <input
                                    type="text"
                                    label="offerEasing"
                                    { ...this.getFieldParameters('globalMarketSettings.offerEasing') }
                                />
                            )
                        }
                        <div className="buttons">
                            <button className="btn btn-primary" type="submit">
                                Change Cash Out Settings
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
export default CashOutSettingsForm;
